import React, { useMemo } from 'react';

import AlertImage from '@pkg/assets/images/alert.png';

import './Alert.scss';

interface YatAlertProps {
    variant?: 'danger' | 'warning' | null;
    message: string;
    classes?: string;
    alertIcon?: boolean;
}

export const Alert = ({ variant, message, classes = '', alertIcon = false }: YatAlertProps) => {
    const classNames = useMemo(() => {
        let classNames = 'yat-alert';
        if (variant) classNames += ` yat-alert--${variant}`;
        if (classes) classNames += ` ${classes}`;

        return classNames;
    }, [variant, classes]);

    return (
        <div role="alert" className={classNames}>
            {alertIcon && <img src={AlertImage} alt="" className="yat-alert__icon" />}
            <p className="yat-alert__message v2-text-xs">{message}</p>
        </div>
    );
};
